// removed by extract-text-webpack-plugin
module.exports = {"PaxListBox":"_2sBir","SelectPax":"_kXzCF","PaxListItem":"_3c5HJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Payment/PassengerSummary/PassengerSummary.scss
// module id = 369
// module chunks = 0